import { UsageAnalyticsEvent } from './toUsageAnalyticsEvent';

const BODY_PREFIX = '{"events":[';
const BODY_SUFFIX = ']}';

const SEPARATOR = ',';

const byteLength = (value: string) => new TextEncoder().encode(value).length;

const ENVELOPE_BYTES = byteLength(BODY_PREFIX) + byteLength(BODY_SUFFIX);
const SEPARATOR_BYTES = byteLength(SEPARATOR);

const isEventTooBigToFitIntoBody = (eventBytes: number, maxBytes: number) =>
  ENVELOPE_BYTES + eventBytes > maxBytes;

const separatorBytesFor = (currentEvents: string[]) =>
  currentEvents.length > 0 ? SEPARATOR_BYTES : 0;

const isNotEnoughRoomForEvent = (
  currentEvents: string[],
  currentBytes: number,
  eventBytes: number,
  maxBytes: number,
) => currentEvents.length > 0 && currentBytes + SEPARATOR_BYTES + eventBytes > maxBytes;

/**
 * Serializes events into JSON request bodies of at most `maxBytes` UTF-8 bytes each.
 * Events that cannot fit in a body on their own are dropped, since they would be rejected anyway.
 */
export function toRequestBodies(events: UsageAnalyticsEvent[], maxBytes: number): string[] {
  const bodies: string[] = [];
  let currentEvents: string[] = [];
  let currentBytes = ENVELOPE_BYTES;

  const closeCurrentBody = () => {
    if (currentEvents.length > 0) {
      bodies.push(`${BODY_PREFIX}${currentEvents.join(SEPARATOR)}${BODY_SUFFIX}`);
    }
    currentEvents = [];
    currentBytes = ENVELOPE_BYTES;
  };

  for (const event of events) {
    const serializedEvent = JSON.stringify(event);
    const eventBytes = byteLength(serializedEvent);
    if (isEventTooBigToFitIntoBody(eventBytes, maxBytes)) {
      continue;
    }

    if (isNotEnoughRoomForEvent(currentEvents, currentBytes, eventBytes, maxBytes)) {
      closeCurrentBody();
    }
    currentBytes += separatorBytesFor(currentEvents) + eventBytes;
    currentEvents.push(serializedEvent);
  }
  closeCurrentBody();

  return bodies;
}
